import Vue from 'vue';
import store from '../store';
import { gsap } from 'gsap';
import SplitText from '../gsap-bonus/SplitText';

Vue.component('story-intro-component', {
    props: {
        storyNumber: {
            value: Number
        },
        stopSounds: {
            value: Array
        },
        playSounds: {
            value: Array
        },
        fadeoutSounds: {
            value: Array
        },
    },
    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            store,
            settings: store.settings
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        var retrievedObject = localStorage.getItem("settings");
        this.settings = JSON.parse(retrievedObject);

        this.store.setStoryIndex(this.storyNumber - 1);

        const el = this.$el.querySelector('.story__text');
        this.splitTextReveal(el);

        Vue.nextTick(() => {
            if (this.stopSounds) {
                EventBus.$emit('stop-sound', this.stopSounds);
            }
            if (this.playSounds) {
                EventBus.$emit('play-sound', this.playSounds);
            }
            if (this.fadeoutSounds) {
                EventBus.$emit('fadeout-sound', this.fadeoutSounds);
            }
        });
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        goToStory(event) {
            if (gtag !== undefined) {
                gtag('event', `intro_screen_${ this.storyNumber }_start`, {
                    'event_label': 'User interacted to start story',
                    'event_category': 'Story Start',
                    'non_interaction': true
                });
            }

            page(event.currentTarget.href);
        },
        
        splitLines(el) {
            const selector = el;
            this.split = new SplitText(selector, {
                type: 'lines',
                linesClass: 'split-line'
            });

            for (let index = 0; index < this.split.lines.length; index++) {
                const line = this.split.lines[index];
                let inner = line.innerHTML;
                inner = `<div class="split-line__inner">${inner}</div>`;
                line.innerHTML = inner;
                line.style.overflow = 'hidden';
            }

            this.splitLinesInner = el.querySelectorAll('.split-line__inner')
            gsap.set(this.splitLinesInner, { translateY: `100%`, opacity: 0 });

        },

        splitTextReveal(el) {
            setTimeout(() => {
                this.splitLines(el);
                gsap.to(el, { duration: 1, opacity: 1, ease: "power2.out" });
                gsap.to(this.splitLinesInner, { translateY: `0%`, duration: 1, opacity: 1, stagger: 0.2, ease: "power2.out" });
            }, 1000);
            window.addEventListener('resize', this.splitTextReveal.resize);
        },

        showNextText() {
            const el = this.$el.querySelector('.story__text');
            gsap.to(el, { duration: 1, opacity: 0, ease: "power2.out", onComplete: () => {
                this.textCount++;
                Vue.nextTick(() => {
                    const el = this.$el.querySelector('.story__text');
                    this.splitTextReveal(el);
                });
            }});
        },  

        showPreviousText() {
            const el = this.$el.querySelector('.story__text');
            gsap.to(el, { duration: 1, opacity: 0, ease: "power2.out", onComplete: () => {
                this.textCount--;
                Vue.nextTick(() => {
                    const el = this.$el.querySelector('.story__text');
                    this.splitTextReveal(el);
                });
            }});
        },  
        
        nextText() {
            // Next text.
            if (this.textCount < this.maxTextCount) {
                console.log(`STORYPART: ${ this.storyPart }`);
                this.showNextText();
                return;
            }

            if (this.storyPart < 9) {
                if (this.$root.book) {
                    const el = this.$el.querySelector('.story__text');
                    gsap.to(el, { duration: 1, opacity: 0, ease: "power2.out"});
                    this.$root.book.next(() => {
                        EventBus.$emit('story-part:show-' + this.storyPart + 1);
                        console.log('emit: story-part:show-' + this.storyPart + 1);
                    });
                }

                return;
            }

            // Go to ending.
            page('/stories/story-'+this.storyNumber+'-end');
        },

        prevText() {
            if (this.textCount > 0) {
                this.showPreviousText();
                return;
            }

            if (this.$root.book) {
                this.$root.book.prev();
            }

            if (this.storyPart > 1) {
                // window.location = '/story-'+this.storyNumber+'-'+(this.storyPart-1);
            }
        },
    },

    beforeDestroy() {
        if (this.splitTextScroll) {
            window.removeEventListener('resize', this.splitTextScroll.resize);
        }

        window.removeEventListener('resize', this.splitTextReveal.resize);
    }
});
